module.exports = __webpack_public_path__ + "static/media/computer.ab55c5b2.png";